export const getEnv = (name: keyof ImportMetaEnv): string | never => {
  let value: string | undefined = window?.dynamicEnv?.[name];

  if (!value) {
    value = import.meta.env[name];
  }

  if (!value) {
    throw new Error(`Environment variable ${name} was not found`);
  }

  return value;
};
